import { Component } from 'vue-property-decorator'
import { Dictionary } from 'vue-router/types/router'
import { sessionStore } from '@/store/session/SessionStoreModule'
import { TCWSessionError } from '@/plugins/TCWBaseError'
import BaseComponent from '@/tcw/components/BaseComponent'

/**
 * コンポーネント基底クラス
 */
@Component
export default class BasePage extends BaseComponent {
  protected get routeParams(): Dictionary<string> {
    return this.$route.params
  }

  /**
   * 初期化処理
   */
  protected created(): void {
    this.execPageInitProc()
  }

  protected async execPageInitProc(): Promise<void> {
    // セッション確認
    if (!sessionStore.has) {
      // セッションデータがない場合、再取得を試みる
      const successRestore = await this.restoreSession()
      if (successRestore) {
        console.log('セッションをリストアしました')
      }
    }

    // アプリ更新のチェック
    if (!this.$tcw.$store.basic.hasUpdate) {
      const newHash = await this.checkUpdateApp()
      if (newHash) {
        this.$tcw.$store.basic.setUpdateState(true)
      }
    }
  }

  /**
   * セッション存続確認
   */
  protected async restoreSession(): Promise<boolean> {
    // トークンを保持しているか
    console.log(this.$cookies.get('_ctkn'))
    if (!this.$cookies.isKey('_ctkn')) {
      return false
    }

    try {
      this.isLoading = true
      await sessionStore.fetch()
      return true
    } catch (e) {
      if (e instanceof TCWSessionError) {
        return false
      } else {
        throw e
      }
    } finally {
      this.isLoading = false
    }
  }
}
